
// Import css files
import { Link } from "react-router-dom";
import sandhl from '../../../../../assets/images/b1iconset.png';
import blogImg from '../../../../../assets/images/blogImg.svg';
import bankingicon from '../../../../../assets/askTheExpertImages/bankingicon.svg';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../../shared/helper";

const BankingArticleDetailsV4Jsx = (props) => {
  const {
    detailsData
  } = props;
  return (
    <>
  <section className="bankinversionfourdetailblog">
        <div className="container">
          <div className="blogsectioone">
            <div className="row">
            <div className="col-lg-7 col-sm-7">
            <div className="tagreal"><span><img src={bankingicon} alt="Banking Icon" /></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</div>
            <div className="blogsectioleft">
              <div className="title">
                <h1>{decodeHtmlEntities(detailsData?.title?.rendered)}</h1></div>
              <p>{detailsData?.acf?.banner_sectionn.short_description}</p>
            </div>
            <div className="d-flex userdetails">
              <div className="userphoto">
                <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
              </div>
              <div className="username">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
            </div>
            </div>
            <div className="col-lg-5 col-sm-5">
              <div className="blogsectioright">
<img src={blogImg} alt="bannermage"/>
             
              </div>
              </div>
            </div>
           
          </div>
         
         
          <div className="blogsectiofour">
            <h2>Benefits </h2>
            <p>The FlexiRewards Credit Card is designed to make your everyday purchases more rewarding. Whether you're a frequent traveler, a student on a budget, or simply someone who wants more value from every dollar spent, this card delivers a powerful combination of flexibility, security, and ongoing perks. Here’s a detailed look at the many benefits it offers: </p>
            <div className="row">
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
              <div className="col">
                <div className="blogsectiofourinner">
                  <div className="serialnumber">01</div>
                  <h4>Welcome Bonus of up to 20,000 Points </h4>
                  <p>Earn 10,000 bonus points with your very first purchase, no minimum required. Plus, get another 10,000 points when you spend $1,000 within the first 90 days of approval. That’s up to 20,000 points just for getting started — a great head start on rewards. </p>
                </div>
              </div>
            </div>
           
          </div>
          <div className="blogsectiofive">
            <div className="row">
              <div className="col-lg-6 col-sm-6 flb">
              <div className="blogsectiofiveleft">
              <div className="blogsectiofiveinner">
                 <h2>How to Apply</h2>
                <p>Getting started with the FlexiRewards Credit Card is quick and simple. Just follow these easy steps to apply and start earning your welcome bonus right away:</p>
              </div>
              <div className="blogsectiofiveimage"><img src={blogImg} alt="blogimage" /></div>
              </div>
              </div>
              <div className="col-lg-6 col-sm-6">
              <div className="blogsectiofivemiddle">
              <div className="blogsectiofivemiddleinner">
                  <ul>
                    <li>
                     <h4>Step 1 : Start Your Application</h4>
                      <p>Jumping into the first option can lead to higher fees.</p>
                    </li>
                    <li>
                      <h4>Step 2 : Start Your Application</h4>
                     <p>Jumping into the first option can lead to higher fees.</p>
                    </li>
                    <li>
                      <h4>Step 3 : Start Your Application</h4>
                     <p>Jumping into the first option can lead to higher fees.</p>
                    </li>
                    <li>
                      <h4>Step 4 : Start Your Application</h4>
                     <p>Jumping into the first option can lead to higher fees.</p>
                    </li>
                    <li>
                      <h4>Step 5 : Start Your Application</h4>
                     <p>Jumping into the first option can lead to higher fees.</p>
                    </li>
                  </ul>
                 
              </div>
     
              </div>
              </div>
             
            </div>
          </div>
          <div className="blogsectiothree">
           
            <div className="row">
             
              <div className="col-lg-12 col-sm-1">
                <div className="blogsectiothreeright">
                 <h2>5 Key Tips for Opening a Bank Account in Canada</h2>
                  <ul>
                    <li>
                      <span>A</span>
                      <h4>Watch for Fees:</h4>
                      <p>Applicants must be Canadian residents and meet the age of majority in their province or territory to qualify for this offer. </p>
                    </li>
                    <li>
                      <span>A</span>
                      <h4>Watch for Fees:</h4>
                      <p>Applicants must be Canadian residents and meet the age of majority in their province or territory to qualify for this offer. </p>
                    </li>
                    <li>
                      <span>A</span>
                      <h4>Watch for Fees:</h4>
                      <p>Applicants must be Canadian residents and meet the age of majority in their province or territory to qualify for this offer. </p>
                    </li>
                    <li>
                      <span>A</span>
                      <h4>Watch for Fees:</h4>
                      <p>Applicants must be Canadian residents and meet the age of majority in their province or territory to qualify for this offer. </p>
                    </li>
                    <li>
                      <span>A</span>
                      <h4>Watch for Fees:</h4>
                      <p>Applicants must be Canadian residents and meet the age of majority in their province or territory to qualify for this offer. </p>
                    </li>
                  
                  </ul>
                </div>
              </div>
            </div>
            
          </div>
          <div className="blogsectiosix">
            <div className="row">
            <div className="col-lg-6 col-sm-6">
                <div className="blogsectiotwoinner">
                  <h2><span><img src={sandhl} alt="blogimage"/></span>Documents Checklist</h2>
                  <ul>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                    <li>Passport or government-issued ID</li>
                  </ul>
                </div>
            </div>
            <div className="col-lg-6 col-sm-6">
            <div className="blogsectiofiveimageset"><img src={blogImg} alt="blogimage" /></div>
            </div>
            </div>
         
            </div>
          <div className="blogsectiotwo">
          <div className="blogsectiotwoinner">
            <h2>Offer Overview</h2>
            <p>
            Apply for the FlexiRewards Credit Card and earn up to 20,000 bonus points as a welcome offer. You’ll receive 10,000 points when you make your first purchase, and an additional 10,000 points when you spend $1,000 in the first 90 days. Plus, enjoy no annual fee for the first year and a competitive rewards program on everyday purchases. It’s a smart way to earn more from the spending you’re already doing. 
            </p>
          </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default BankingArticleDetailsV4Jsx;
